import React from 'react'
import PropTypes from 'prop-types'
import MediaUtilityService from 'common/services/MediaUtilityService'
import imageConfig from 'common/constants/imageConfig'

import styles from './style.css.scss'

const Avatar = ({ url, onClick, color }) => {
  const handleClick = () => onClick && onClick()

  const imgUrl = MediaUtilityService.getImageUrl({
    image: {url},
    transformation: {
      width: styles.userImageSize,
      height: styles.userImageSize,
      ...imageConfig["face"]
    }
  })

  return imgUrl ? (
    <span
      className='avatar'
      style={{ backgroundImage: `url('${imgUrl}')` }}
      onClick={handleClick} />
  ) : (
    <span
      className='icon-avatar-user'
      style={{color}}
      onClick={handleClick} />
  )
}

Avatar.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string.isRequired
}

Avatar.defaultProps = {
  color: 'inherit'
}

export default Avatar

